(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keldry-arcticclip-0521"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function moneyFormat(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }

    function initSection(root) {
      var sectionId = root.dataset.sectionId;
      var skipCart = root.dataset.skipCart === 'true';
      var dataEl = root.querySelector('[data-kac-variants]');
      var variants = [];
      if (dataEl) {
        try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
      }
      var form = root.querySelector('#kac-form-' + sectionId);
      var variantInput = root.querySelector('#kac-variantId-' + sectionId);
      var priceLabel = root.querySelector('#kac-priceLabel-' + sectionId);
      var priceWas = root.querySelector('#kac-priceWas-' + sectionId);
      var priceSave = root.querySelector('#kac-priceSave-' + sectionId);
      var skuName = root.querySelector('#kac-skuName-' + sectionId);
      var addBtn = root.querySelector('#kac-addBtn-' + sectionId);
      var addBtnLabel = root.querySelector('#kac-addBtnLabel-' + sectionId);
      var stickyAtc = root.querySelector('#kac-stickyAtc-' + sectionId);
      var stickyPrice = root.querySelector('#kac-stickyPrice-' + sectionId);
      var stickyWas = root.querySelector('#kac-stickyWas-' + sectionId);
      var stickyBtnPrice = root.querySelector('#kac-stickyBtnPrice-' + sectionId);
      var mainImg = root.querySelector('#kac-mainImg-' + sectionId);

      function findVariant(id) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(id)) return variants[i];
        }
        return null;
      }

      function selectVariant(variantId) {
        var v = findVariant(variantId);
        if (!v) return;
        if (variantInput) variantInput.value = v.id;
        if (skuName) skuName.textContent = v.title;
        if (priceLabel) priceLabel.textContent = v.price_formatted;
        if (priceWas) {
          if (v.compare_at_price > v.price) {
            priceWas.textContent = v.compare_formatted;
            priceWas.removeAttribute('hidden');
          } else {
            priceWas.setAttribute('hidden', '');
          }
        }
        if (priceSave) {
          if (v.compare_at_price > v.price) {
            var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
            priceSave.textContent = 'Save ' + pct + '%';
            priceSave.removeAttribute('hidden');
          } else {
            priceSave.setAttribute('hidden', '');
          }
        }
        if (addBtn) {
          if (v.available) {
            addBtn.disabled = false;
            if (addBtnLabel) addBtnLabel.textContent = (root.dataset.buyLabel || 'Buy now') + ' · ' + v.price_formatted;
          } else {
            addBtn.disabled = true;
            if (addBtnLabel) addBtnLabel.textContent = root.dataset.soldOutLabel || 'Sold out';
          }
        }
        if (stickyPrice) stickyPrice.textContent = v.price_formatted;
        if (stickyWas) {
          if (v.compare_at_price > v.price) {
            stickyWas.textContent = v.compare_formatted;
            stickyWas.removeAttribute('hidden');
          } else {
            stickyWas.setAttribute('hidden', '');
          }
        }
        if (stickyBtnPrice) stickyBtnPrice.textContent = ' · ' + v.price_formatted;

        var cards = root.querySelectorAll('.kac-sku-card, .kac-bundle');
        for (var i = 0; i < cards.length; i++) {
          var isMatch = cards[i].dataset.variantId === String(v.id);
          if (cards[i].classList.contains('kac-bundle')) {
            if (isMatch) cards[i].classList.add('kac-bundle--selected');
            else cards[i].classList.remove('kac-bundle--selected');
          } else {
            if (isMatch) cards[i].classList.add('kac-sku-card--active');
            else cards[i].classList.remove('kac-sku-card--active');
          }
        }
      }

      var skuCards = root.querySelectorAll('.kac-sku-card, .kac-bundle');
      for (var i = 0; i < skuCards.length; i++) {
        skuCards[i].addEventListener('click', function() {
          if (this.disabled) return;
          selectVariant(this.dataset.variantId);
        });
      }

      var estCountdown = root.querySelector('#kac-estCountdown-' + sectionId);
      var estDate = root.querySelector('#kac-estDate-' + sectionId);
      if (estCountdown || estDate) {
        function updateDelivery() {
          var now = new Date();
          var endOfDay = new Date();
          endOfDay.setHours(23, 59, 59, 999);
          var diff = endOfDay - now;
          var hours = Math.floor(diff / (1000 * 60 * 60));
          var mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
          if (estCountdown) estCountdown.textContent = hours + 'h ' + mins + 'm';
          var deliveryDate = new Date();
          deliveryDate.setDate(deliveryDate.getDate() + 7);
          if (estDate) estDate.textContent = deliveryDate.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
        }
        updateDelivery();
        setInterval(updateDelivery, 60000);
      }

      var thumbs = root.querySelectorAll('.kac-thumb');
      for (var j = 0; j < thumbs.length; j++) {
        if (thumbs[j].dataset.img) {
          var pre = new Image();
          pre.src = thumbs[j].dataset.img;
        }
        thumbs[j].addEventListener('click', function() {
          for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.remove('kac-thumb--active');
          this.classList.add('kac-thumb--active');
          if (mainImg && this.dataset.img) mainImg.src = this.dataset.img;
        });
      }

      var scrollers = root.querySelectorAll('[data-kac-scroll-to-add]');
      for (var s = 0; s < scrollers.length; s++) {
        scrollers[s].addEventListener('click', function() {
          if (addBtn) addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      if (stickyAtc && addBtn) {
        if (stickyAtc.parentNode !== document.body) {
          var rootInline = root.getAttribute('style') || '';
          var existingInline = stickyAtc.getAttribute('style') || '';
          stickyAtc.setAttribute('style', existingInline + ';' + rootInline);
          document.body.appendChild(stickyAtc);
        }
        function updateSticky() {
          var rect = addBtn.getBoundingClientRect();
          if (rect.bottom < 0) stickyAtc.classList.add('kac-visible');
          else stickyAtc.classList.remove('kac-visible');
        }
        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', updateSticky);
        updateSticky();
      }

      if (form && skipCart) {
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          var btn = form.querySelector('button[type="submit"]');
          if (btn) btn.disabled = true;
          var fd = new FormData(form);
          fetch('/cart/add.js', {
            method: 'POST',
            body: fd,
            headers: { 'Accept': 'application/javascript' }
          }).then(function(res) {
            if (res.ok) {
              window.location.href = '/checkout';
            } else {
              if (btn) btn.disabled = false;
              return res.json().then(function(err) { alert(err.description || 'Could not add to cart'); });
            }
          }).catch(function() {
            if (btn) btn.disabled = false;
          });
        });
      }
    }

    var sections = document.querySelectorAll('.kac-page');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keldry-misttower-0522"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initSection(root) {
      var sectionId = root.dataset.sectionId;
      var skipCart = root.dataset.skipCart === 'true';
      var atcText = root.dataset.atcText || 'Add to Cart';
      var soldOutText = root.dataset.soldOutText || 'Sold out';
      var dataEl = root.querySelector('[data-km-variants]');
      var variants = [];
      if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) {} }

      var form = root.querySelector('#km-form-' + sectionId);
      var variantInput = root.querySelector('#km-variantId-' + sectionId);
      var priceNow = root.querySelector('#km-priceNow-' + sectionId);
      var priceWas = root.querySelector('#km-priceWas-' + sectionId);
      var priceSave = root.querySelector('#km-priceSave-' + sectionId);
      var addBtn = root.querySelector('#km-addBtn-' + sectionId);
      var addBtnLabel = root.querySelector('#km-addBtnLabel-' + sectionId);
      var finalLabel = root.querySelector('#km-finalLabel-' + sectionId);
      var mainImg = root.querySelector('#km-mainImg-' + sectionId);
      var stickyAtc = root.querySelector('#km-stickyAtc-' + sectionId);
      var stickyPrice = root.querySelector('#km-stickyPrice-' + sectionId);
      var stickyWas = root.querySelector('#km-stickyWas-' + sectionId);
      var stickyBtnPrice = root.querySelector('#km-stickyBtnPrice-' + sectionId);

      function findVariant(id) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(id)) return variants[i];
        }
        return null;
      }

      function selectVariant(variantId) {
        var v = findVariant(variantId);
        if (!v) return;
        if (variantInput) variantInput.value = v.id;
        if (priceNow) priceNow.textContent = v.price_formatted;
        if (priceWas) {
          if (v.compare_at_price > v.price) { priceWas.textContent = v.compare_formatted; priceWas.removeAttribute('hidden'); }
          else { priceWas.setAttribute('hidden', ''); }
        }
        if (priceSave) {
          if (v.compare_at_price > v.price) {
            var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
            priceSave.textContent = 'SAVE ' + pct + '%';
            priceSave.removeAttribute('hidden');
          } else { priceSave.setAttribute('hidden', ''); }
        }
        if (addBtn) {
          if (v.available) {
            addBtn.disabled = false;
            if (addBtnLabel) addBtnLabel.textContent = atcText + ' - ' + v.price_formatted;
          } else {
            addBtn.disabled = true;
            if (addBtnLabel) addBtnLabel.textContent = soldOutText;
          }
        }
        if (finalLabel) finalLabel.textContent = atcText + ' - ' + v.price_formatted;
        if (stickyPrice) stickyPrice.textContent = v.price_formatted;
        if (stickyWas) {
          if (v.compare_at_price > v.price) { stickyWas.textContent = v.compare_formatted; stickyWas.removeAttribute('hidden'); }
          else { stickyWas.setAttribute('hidden', ''); }
        }
        if (stickyBtnPrice) stickyBtnPrice.textContent = v.price_formatted;

        var bundles = root.querySelectorAll('.km-bundle');
        for (var i = 0; i < bundles.length; i++) {
          if (bundles[i].dataset.variantId === String(v.id)) bundles[i].classList.add('km-bundle--selected');
          else bundles[i].classList.remove('km-bundle--selected');
        }
      }

      var bundles = root.querySelectorAll('.km-bundle');
      for (var i = 0; i < bundles.length; i++) {
        bundles[i].addEventListener('click', function() {
          if (this.disabled) return;
          selectVariant(this.dataset.variantId);
        });
      }

      var thumbs = root.querySelectorAll('.km-gallery-thumb');
      for (var j = 0; j < thumbs.length; j++) {
        if (thumbs[j].dataset.img) {
          var pre = new Image();
          pre.src = thumbs[j].dataset.img;
        }
        thumbs[j].addEventListener('click', function() {
          for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.remove('km-gallery-thumb--active');
          this.classList.add('km-gallery-thumb--active');
          if (mainImg && this.dataset.img) mainImg.src = this.dataset.img;
        });
      }

      var compTabs = root.querySelectorAll('.km-comp-tab');
      var compWrap = root.querySelector('.km-comp-wrap');
      for (var c = 0; c < compTabs.length; c++) {
        compTabs[c].addEventListener('click', function() {
          if (compWrap) compWrap.setAttribute('data-active', this.dataset.comp);
          for (var d = 0; d < compTabs.length; d++) compTabs[d].classList.remove('km-comp-tab--active');
          this.classList.add('km-comp-tab--active');
        });
      }

      var tabBtns = root.querySelectorAll('.km-tab-btn');
      for (var t = 0; t < tabBtns.length; t++) {
        tabBtns[t].addEventListener('click', function() {
          var id = this.dataset.tab;
          for (var u = 0; u < tabBtns.length; u++) tabBtns[u].classList.remove('km-tab-btn--active');
          this.classList.add('km-tab-btn--active');
          var panels = root.querySelectorAll('.km-tab-panel');
          for (var w = 0; w < panels.length; w++) {
            if (panels[w].dataset.panel === id) panels[w].classList.add('km-tab-panel--active');
            else panels[w].classList.remove('km-tab-panel--active');
          }
        });
      }

      var scrollers = root.querySelectorAll('[data-km-scroll-to-add]');
      for (var s = 0; s < scrollers.length; s++) {
        scrollers[s].addEventListener('click', function() {
          if (addBtn) addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      var estCountdown = root.querySelector('#km-estCountdown-' + sectionId);
      var estDate = root.querySelector('#km-estDate-' + sectionId);
      if (estCountdown || estDate) {
        function updateDelivery() {
          var now = new Date();
          var endOfDay = new Date();
          endOfDay.setHours(23, 59, 59, 999);
          var diff = endOfDay - now;
          var hours = Math.floor(diff / (1000 * 60 * 60));
          var mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
          if (estCountdown) estCountdown.textContent = hours + 'h ' + mins + 'm';
          var deliveryDate = new Date();
          deliveryDate.setDate(deliveryDate.getDate() + 7);
          if (estDate) estDate.textContent = deliveryDate.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
        }
        updateDelivery();
        setInterval(updateDelivery, 60000);
      }

      if (stickyAtc && addBtn) {
        if (stickyAtc.parentNode !== document.body) {
          var rootInline = root.getAttribute('style') || '';
          var existingInline = stickyAtc.getAttribute('style') || '';
          stickyAtc.setAttribute('style', existingInline + ';' + rootInline);
          document.body.appendChild(stickyAtc);
        }
        function updateSticky() {
          var rect = addBtn.getBoundingClientRect();
          if (rect.bottom < 0) stickyAtc.classList.add('km-visible');
          else stickyAtc.classList.remove('km-visible');
        }
        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', updateSticky);
        updateSticky();
      }

      if (form && skipCart) {
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          var btn = form.querySelector('button[type="submit"]');
          if (btn) btn.disabled = true;
          var fd = new FormData(form);
          fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/javascript' } })
            .then(function(res) {
              if (res.ok) { window.location.href = '/checkout'; }
              else { if (btn) btn.disabled = false; return res.json().then(function(err) { alert(err.description || 'Could not add to cart'); }); }
            }).catch(function() { if (btn) btn.disabled = false; });
        });
      }
    }
    var sections = document.querySelectorAll('.km-page');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keldry-storagebox-0522"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initSection(root) {
      var sectionId = root.dataset.sectionId;
      var skipCart = root.dataset.skipCart === 'true';
      var dataEl = root.querySelector('[data-ksb-variants]');
      var variants = [];
      if (dataEl) {
        try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
      }
      var form = root.querySelector('#ksb-form-' + sectionId);
      var variantInput = root.querySelector('#ksb-variantId-' + sectionId);
      var priceNow = root.querySelector('#ksb-priceNow-' + sectionId);
      var priceWas = root.querySelector('#ksb-priceWas-' + sectionId);
      var priceSave = root.querySelector('#ksb-priceSave-' + sectionId);
      var addBtn = root.querySelector('#ksb-addBtn-' + sectionId);
      var addBtnLabel = root.querySelector('#ksb-addBtnLabel-' + sectionId);
      var mainImg = root.querySelector('#ksb-mainImg-' + sectionId);
      var stickyAtc = root.querySelector('#ksb-stickyAtc-' + sectionId);
      var stickyPrice = root.querySelector('#ksb-stickyPrice-' + sectionId);
      var stickyWas = root.querySelector('#ksb-stickyWas-' + sectionId);
      var stickyBtnPrice = root.querySelector('#ksb-stickyBtnPrice-' + sectionId);
      var atcText = root.dataset.atcText || 'Add to Cart';
      var soldOutText = root.dataset.soldOutText || 'Sold out';

      function findVariant(id) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(id)) return variants[i];
        }
        return null;
      }

      function moneyDelta(now, was) {
        var diff = was - now;
        if (diff <= 0) return '';
        var d = diff / 100;
        if (d % 1 === 0) return '$' + d;
        return '$' + d.toFixed(2);
      }

      function selectVariant(variantId) {
        var v = findVariant(variantId);
        if (!v) return;
        if (variantInput) variantInput.value = v.id;
        if (priceNow) priceNow.textContent = v.price_formatted;
        if (priceWas) {
          if (v.compare_at_price > v.price) {
            priceWas.textContent = v.compare_formatted;
            priceWas.removeAttribute('hidden');
          } else { priceWas.setAttribute('hidden', ''); }
        }
        if (priceSave) {
          if (v.compare_at_price > v.price) {
            priceSave.textContent = 'Save ' + moneyDelta(v.price, v.compare_at_price);
            priceSave.removeAttribute('hidden');
          } else { priceSave.setAttribute('hidden', ''); }
        }
        if (addBtn) {
          if (v.available) {
            addBtn.disabled = false;
            if (addBtnLabel) addBtnLabel.textContent = atcText + ' · ' + v.price_formatted;
          } else {
            addBtn.disabled = true;
            if (addBtnLabel) addBtnLabel.textContent = soldOutText;
          }
        }
        var bundles = root.querySelectorAll('.ksb-bundle');
        for (var i = 0; i < bundles.length; i++) {
          if (bundles[i].dataset.variantId === String(v.id)) bundles[i].classList.add('ksb-bundle--active');
          else bundles[i].classList.remove('ksb-bundle--active');
        }
        if (stickyPrice) stickyPrice.textContent = v.price_formatted;
        if (stickyWas) {
          if (v.compare_at_price > v.price) {
            stickyWas.textContent = v.compare_formatted;
            stickyWas.removeAttribute('hidden');
          } else { stickyWas.setAttribute('hidden', ''); }
        }
        if (stickyBtnPrice) stickyBtnPrice.textContent = ' · ' + v.price_formatted;
      }

      var bundles = root.querySelectorAll('.ksb-bundle');
      for (var i = 0; i < bundles.length; i++) {
        bundles[i].addEventListener('click', function() {
          if (this.disabled) return;
          selectVariant(this.dataset.variantId);
        });
      }

      var thumbs = root.querySelectorAll('.ksb-thumb');
      for (var j = 0; j < thumbs.length; j++) {
        if (thumbs[j].dataset.img) {
          var pre = new Image();
          pre.src = thumbs[j].dataset.img;
        }
        thumbs[j].addEventListener('click', function() {
          for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.remove('ksb-thumb--active');
          this.classList.add('ksb-thumb--active');
          if (mainImg && this.dataset.img) mainImg.src = this.dataset.img;
        });
      }

      var scrollers = root.querySelectorAll('[data-ksb-scroll-to-add]');
      for (var s = 0; s < scrollers.length; s++) {
        scrollers[s].addEventListener('click', function() {
          if (addBtn) addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      var estCountdown = root.querySelector('#ksb-estCountdown-' + sectionId);
      var estDate = root.querySelector('#ksb-estDate-' + sectionId);
      if (estCountdown || estDate) {
        function updateDelivery() {
          var now = new Date();
          var endOfDay = new Date();
          endOfDay.setHours(23, 59, 59, 999);
          var diff = endOfDay - now;
          var hours = Math.floor(diff / (1000 * 60 * 60));
          var mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
          if (estCountdown) estCountdown.textContent = hours + 'h ' + mins + 'm';
          var deliveryDate = new Date();
          deliveryDate.setDate(deliveryDate.getDate() + 7);
          if (estDate) estDate.textContent = deliveryDate.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
        }
        updateDelivery();
        setInterval(updateDelivery, 60000);
      }

      if (stickyAtc && addBtn) {
        if (stickyAtc.parentNode !== document.body) {
          var rootInline = root.getAttribute('style') || '';
          var existingInline = stickyAtc.getAttribute('style') || '';
          stickyAtc.setAttribute('style', existingInline + ';' + rootInline);
          document.body.appendChild(stickyAtc);
        }
        function updateSticky() {
          var rect = addBtn.getBoundingClientRect();
          if (rect.bottom < 0) stickyAtc.classList.add('ksb-visible');
          else stickyAtc.classList.remove('ksb-visible');
        }
        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', updateSticky);
        updateSticky();
      }

      if (form && skipCart) {
        form.addEventListener('submit', function(e) {
          e.preventDefault();
          var btn = form.querySelector('button[type="submit"]');
          if (btn) btn.disabled = true;
          var fd = new FormData(form);
          fetch('/cart/add.js', {
            method: 'POST',
            body: fd,
            headers: { 'Accept': 'application/javascript' }
          }).then(function(res) {
            if (res.ok) {
              window.location.href = '/checkout';
            } else {
              if (btn) btn.disabled = false;
              return res.json().then(function(err) { alert(err.description || 'Could not add to cart'); });
            }
          }).catch(function() {
            if (btn) btn.disabled = false;
          });
        });
      }
    }

    var sections = document.querySelectorAll('.ksb-page');
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  })();

  } catch(e) { console.error(e); }
})();
})();
